import { getCmsNetworkDetailAction } from "../../../Actions/LogicActions/CmsNetworkMapStations/GetCmsNetworkDetailAction";
import { tripBookClickAction } from "../../../Actions/UIActions/CmsNetworkMapStations/TripBookClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetBookingCodesActionParams, IGetNetworkDetailActionParams } from "../../../Orchestrator/Types/Index";

class NetworkDetailInitStep extends StepFlow {
    get stepName() { return "NetworkDetailInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IGetNetworkDetailActionParams, void>({
                eventName: evtTree.NetowrkDetail.Get,
                handler: async ({ data }) => {
                    if (data?.slug) {
                        getCmsNetworkDetailAction.setParams(data!);
                        getCmsNetworkDetailAction.execute();
                    }
                },
            })
        );

        this.registerEventSubscription(
            _eventBus.on<IGetBookingCodesActionParams, void>({
                eventName: evtTree.NetowrkDetail.Trip.Click,
                handler: async (data) => {
                    if (data) {
                        tripBookClickAction.setParams(data.data!);
                        tripBookClickAction.execute();
                    }
                },
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.NetowrkDetail.Back,
                handler: async () => {

                    _eventBus.emit({
                        eventName: "FLOW_CLOSE",
                        data: `NetworkDetailFlow`,
                    });

                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/networks-maps-stations",
                    });
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        console.log("NetworkDetail Init Step Execute...")
    }
}

export const NetworkDetailInitStepDeclaration = new StepDefinition({
    stepName: "NetworkDetailInit_Step",
    stepClass: NetworkDetailInitStep
});